import { createFileRoute } from '@tanstack/react-router'
import { RefundDetailPage } from '../../../../features/refunds/refund-pages'
import { documentActionSearchSchema } from '../../../../features/sales/document-action'

export const Route = createFileRoute('/_app/refunds/$refundId/')({
  validateSearch: documentActionSearchSchema,
  component: RefundDetailPage,
})
